/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Updated_BodyInputs */

const en_password_reset_updated_body = /** @type {(inputs: Password_Reset_Updated_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can now log in with your new password.`)
};

const es_password_reset_updated_body = /** @type {(inputs: Password_Reset_Updated_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya puedes iniciar sesión con tu nueva contraseña.`)
};

/**
* | output |
* | --- |
* | "You can now log in with your new password." |
*
* @param {Password_Reset_Updated_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_updated_body = /** @type {((inputs?: Password_Reset_Updated_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Updated_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_updated_body(inputs)
	return en_password_reset_updated_body(inputs)
});